import { HostingModel, ServerModel } from '@/models'
import { CartModalManager as BaseCartModalManager } from '@/views'
import { Modals } from '@/core'
import { PricingTableModalView } from './pricing-table.modal'

export class CartModalManager extends BaseCartModalManager {
  private pricingTableModalView: PricingTableModalView | null = null

  setPricingTableView(view: PricingTableModalView): void {
    this.pricingTableModalView = view
  }

  override open(modalName: Modals): void {
    this.closeAll()

    switch (modalName) {
      case Modals.PRICING:
        this.pricingTableModalView?.open()
        break
      case Modals.DOMAIN:
        this.domainSelectionModalView.open()
        break
      case Modals.SERVER:
        this.serverConfigModalView.open()
        break
      case Modals.CUSTOM_FIELDS:
        this.customFieldModalView.open()
        break
      default:
        throw new Error('CartModalManager: undefined modal name')
    }
  }

  override onSubmit(
    modalName: Modals,
    model: HostingModel | ServerModel
  ): Promise<HostingModel | ServerModel> {
    switch (modalName) {
      case Modals.PRICING:
        if (!this.pricingTableModalView) {
          throw new Error(
            "CartModalManager: can't listen to pricingTable since the view is undefined"
          )
        }
        return this.pricingTableModalView?.onSubmit(model)
      case Modals.DOMAIN:
        return this.domainSelectionModalView.onSubmit(model)
      case Modals.SERVER:
        return this.serverConfigModalView.onSubmit(model as ServerModel)
      case Modals.CUSTOM_FIELDS:
        return this.customFieldModalView.onSubmit(model)
      default:
        throw new Error('CartModalManager: undefined modal name')
    }
  }

  protected override closeAll(): void {
    this.pricingTableModalView?.close()
    this.domainSelectionModalView.close()
    this.customFieldModalView.close()
    this.serverConfigModalView.close()
  }
}
